// extracted by mini-css-extract-plugin
module.exports = {"locale-modal":"locale-modal___1BTFz","locale-wraper":"locale-wraper___1msWS","select-group":"select-group___dMmdV","title":"title___2slVV"};